"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    heading: {
      margin: spacing(2)
    },
    wrapper: {
      minWidth: 'auto'
    }
  };
});

var CertificateAssignInspectors = function CertificateAssignInspectors(_ref2) {
  var users = _ref2.users,
      assignedUsers = _ref2.assignedUsers,
      editable = _ref2.editable,
      info = _ref2.info,
      onChange = _ref2.onChange,
      handleUserClick = _ref2.handleUserClick;
  var classes = useStyles();
  var Wrapper = onChange ? _core.ListItemSecondaryAction : _core.ListItemIcon;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, info && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.heading,
    variant: "body1"
  }, info), /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true,
    className: classes.root
  }, users.map(function (_ref3) {
    var _id = _ref3._id,
        fullName = _ref3.fullName,
        avatar = _ref3.avatar;
    var labelId = "checkbox-list-secondary-label-".concat(_id);
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, _extends({
      key: _id
    }, handleUserClick && editable ? {
      button: true,
      onClick: function onClick() {
        return handleUserClick(_id);
      }
    } : {}), /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      src: avatar === null || avatar === void 0 ? void 0 : avatar.src
    })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      id: labelId,
      primary: fullName
    }), /*#__PURE__*/_react["default"].createElement(Wrapper, {
      className: classes.wrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
      color: "primary",
      edge: "end",
      disabled: !editable,
      checked: !!assignedUsers[_id],
      name: _id
    }, onChange ? {
      onChange: onChange
    } : {
      disableRipple: true,
      inputProps: {
        'aria-labelledby': labelId
      }
    }))));
  })));
};

var _default = CertificateAssignInspectors;
exports["default"] = _default;